export const productConfig = {
  id: 'bodybase',
  landingUrl: 'https://bodybase.pro',
  paymentFailUrl: 'https://bodybase.pro/fail',
  /** Возврат в Mini App после внешней оплаты; прод переопределить через VUE_APP_TELEGRAM_BOT_URL */
  telegramBotUrl: 'https://t.me/BodybaseStageDev_bot',
  pwa: {
    name: 'BodyBase',
    shortName: 'BodyBase',
    description: 'BodyBase',
    themeColor: '#1B3155',
    backgroundColor: '#1B3155',
    icons: [
      {
        src: '/products/bodybase/icons/android-chrome-192x192.png',
        sizes: '192x192',
        type: 'image/png',
      },
      {
        src: '/products/bodybase/icons/android-chrome-512x512.png',
        sizes: '512x512',
        type: 'image/png',
      },
      {
        src: '/products/bodybase/icons/apple-touch-icon.png',
        sizes: '180x180',
        type: 'image/png',
      },
    ],
  },
}
